import { PeopleBadgeList } from '@/routes/_layout/scheduling/student-groups/-components/people-badge-list';
import { getSessionSubstitutionRequestSummary } from '@airreading/common';
import {
  AdminSession,
  SubstitutionRequestStatus,
  VideoConferenceType,
  SubstitutionRequestOrigin,
} from '@airreading/common/data';

interface OriginalTeacherDisplayProps {
  session: AdminSession;
  testId?: string;
}

export const OriginalTeacherDisplay = ({ session, testId }: OriginalTeacherDisplayProps) => {
  const { mostRecentRequest } = getSessionSubstitutionRequestSummary(session);
  const hasPendingRequest = mostRecentRequest?.status === SubstitutionRequestStatus.pending;
  const isAutomaticConflict = mostRecentRequest?.origin === SubstitutionRequestOrigin.automatic_conflict;
  const isZoom = session.videoConferenceType === VideoConferenceType.zoom;
  const { coach } = session;

  if (isZoom && hasPendingRequest && isAutomaticConflict) {
    return <span data-testid={testId}>Pending substitute teacher</span>;
  }
  if (!coach) {
    return null;
  }
  return <PeopleBadgeList people={[coach]} testId={testId} />;
};
